// export const API_SERVER = "http://127.0.0.1:8000/api/";
// export const WEBSOCKET_URL = "ws://127.0.0.1:8000/ws/";
// export const ADMIN_DASHBOARD = "http://127.0.0.1:8000/";
export const WEBSOCKET_URL = "wss://plankton-app-8i732.ondigitalocean.app/ws/";
export const API_SERVER = "https://plankton-app-8i732.ondigitalocean.app/api/";
export const ADMIN_DASHBOARD = "https://plankton-app-8i732.ondigitalocean.app/";
